export enum PaymentType {
  PAYPAL,
  CREDITCARD,
  BANKTRANSFER,
  ZERO
}
